import { createSlice } from "@reduxjs/toolkit";

/**
 * globalLoaderSlice — WEB-ONLY today. `apps/mobile` has no equivalent.
 *
 * A FOLDER with a single `index.ts`, deliberately, even though nothing here is
 * platform-specific (no logout `extraReducers`, no divergence, no platform APIs). Consumers
 * import `@rista/core/redux-store/slices/globalLoaderSlice` either way — a folder resolves
 * via `index`, a bare file resolves directly — so this costs nothing now and means that if
 * mobile ever needs its own behaviour, the change is *adding* `index.desktop.ts` +
 * `index.native.ts` beside this file rather than converting a file into a folder.
 *
 * Tracks in-flight request count for the global loader; driven by
 * `apps/web/src/utils/requestManager/globalLoaderReduxSync.ts`.
 *
 * Note `setActiveRequestsCount` is written in METHOD shorthand in the app, not as an arrow —
 * kept that way. Neither `globalLoaderSlice` nor `GlobalLoaderState` is exported by the app,
 * so neither is exported here.
 */
type GlobalLoaderState = {
  activeRequests: number;
};

const initialState: GlobalLoaderState = {
  activeRequests: 0,
};
const globalLoaderSlice = createSlice({
  name: "globalLoader",
  initialState,
  reducers: {
    setActiveRequestsCount(state, action) {
      state.activeRequests = action.payload;
    },
  },
});

export const { setActiveRequestsCount } = globalLoaderSlice.actions;

export default globalLoaderSlice.reducer;
